export const COLUMN_FIELD_MAPPING: Record<string, string> = {
  status: 'currentStatus',
  currentStep: 'currentSchritt',
  createdAt: 'erstelltDatum',
  currentGestartedAm: 'currentGestartetAm',
  auftragsnummer: 'auftragsnummer',
  kundennummer: 'kundennummer',
  vertragsnummer: 'vertragsnummer',
  correlationId: 'id',
  externeId: 'externeId',
  vorgangType: 'vorgangType',
  externerName: 'externerName',
  error: 'errorMessage',
  fehlertyp: 'errorStep',
  lockedBy: 'lockedBy',
  dokumentTyp: 'dokumentTyp',
  archivierungsstatus: 'archivierungsstatus',
  unterdrueckung: 'unterdrueckung',
};
